import React, { useState } from "react";
import { ClientInvoiceManagement } from "./ClientInvoiceManagement";
import { ClientViewInvoiceDetails } from "./ClientViewInvoiceDetails";
import { ClientInvoice } from "@/types/client";
import ApiService from "@/services/api";
import { EndpointKeys } from "@/config/api";

type ViewState = "management" | "view";

export function ClientInvoicesContainer() {
  const [currentView, setCurrentView] = useState<ViewState>("management");
  const [selectedInvoice, setSelectedInvoice] = useState<ClientInvoice | null>(null);

  const handleViewInvoice = async (invoice: ClientInvoice) => {
    try {
      // Fetch detailed invoice data
      const detailedInvoice = await ApiService.request<ClientInvoice>(
        EndpointKeys.GET_CLIENT_INVOICE_DETAILS,
        {
          method: "GET",
          urlParams: { invoiceId: invoice.id },
        }
      );
      setSelectedInvoice(detailedInvoice);
      setCurrentView("view");
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      // Fallback to using the invoice data we already have
      setSelectedInvoice(invoice);
      setCurrentView("view");
    }
  };

  const handleBackToManagement = () => {
    setSelectedInvoice(null);
    setCurrentView("management");
  };

  const handleInvoiceAction = async () => {
    // After approve/reject, refresh the current invoice details instead of going back
    if (selectedInvoice) {
      try {
        // Fetch updated invoice data
        const updatedInvoice = await ApiService.request<ClientInvoice>(
          EndpointKeys.GET_CLIENT_INVOICE_DETAILS,
          {
            method: "GET",
            urlParams: { invoiceId: selectedInvoice.id },
          }
        );
        setSelectedInvoice(updatedInvoice);
      } catch (error) {
        console.error("Error refreshing invoice details:", error);
        // If refresh fails, go back to management
        setSelectedInvoice(null);
        setCurrentView("management");
      }
    }
  };

  if (currentView === "view" && selectedInvoice) {
    return (
      <ClientViewInvoiceDetails
        invoice={selectedInvoice}
        onBack={handleBackToManagement}
        onInvoiceAction={handleInvoiceAction}
      />
    );
  }

  return (
    <ClientInvoiceManagement onViewInvoice={handleViewInvoice} />
  );
} 